export const EMAIL_VERIFICATION_STEP = 'EmailVerification';
export const MCI_UPLOAD_STEP = 'MCIUpload';
export const INDIA_COUNTRY_CODE = 'IN';
export const INDIA_COUNTRY_ID = 101;
export const MIN_CORRECT_ANSWERS = 'minimumCorrectAnswers';
export const TOTAL_QUESTIONS_DEFAULT = 10;

export const EUROPEAN_COUNTRIES = [2, 5, 14, 20, 21, 27, 33, 58, 68, 74, 75, 82, 85, 99, 100, 105, 107, 120, 125, 126, 127, 135, 144, 145, 164, 175, 176, 180, 181, 189, 193, 197, 198, 205, 211, 212, 228, 230, 251];
export const US_COUNTRIES = [38, 231];

export const STEPS_IN_PROFILE_COMPLETION = [
	{
		no: 1,
		name: MCI_UPLOAD_STEP,
		forAllUsers: false,
		forUserCountries: [INDIA_COUNTRY_CODE]
	},
	{
		no: 2,
		name: EMAIL_VERIFICATION_STEP,
		forAllUsers: true
	}
]

export const USEFUL_OPTIONS = [
    {value: 1, label: 'Extremely Useful'},
    {value: 2, label: 'Useful'},
    {value: 3, label: 'Fairly Useful'},
    {value: 4, label: 'Not Useful'}
];

export const MUCH_OPTIONS = [
    {value: 1, label: 'Very Much'},
    {value: 2, label: 'Somewhat'},
    {value: 3, label: 'Not Much'},
    {value: 4, label: 'Not at All'},
    {value: 5, label: 'Undecided'}
];

export const YES_OPTIONS = [
    {value: 1, label: 'Yes, All'},
    {value: 2, label: 'Yes, for the Majority'},
    {value: 3, label: 'Yes, but only a small Part'},
    {value: 4, label: 'No'},
    {value: 5, label: 'Undecided/don’t know'}
];

export const ALWAYS_OPTIONS = [
    {value: 1, label: 'Yes, Always/ Almost Always'},
    {value: 2, label: 'Yes, Sometimes'},
    {value: 3, label: 'Only Rarely'},
    {value: 4, label: 'Never'},
    {value: 5, label: 'Undecided'}
];

export const USEFUL_OPTIONS_WITH_UNDECIDED = [
    ...USEFUL_OPTIONS,
    {value: 5, label: 'Undecided/DNA'}
];

export const GOODNESS_OPTIONS = [
    {value: 1, label: 'Excellent'},
    {value: 2, label: 'Good'},
    {value: 3, label: 'Fairly Good'},
    {value: 4, label: 'Poor'},
    {value: 5, label: 'Very Poor'}
];

export const AGREE_OPTIONS = [
    {value: 1, label: 'Strongly Agree'},
    {value: 2, label: 'Rather Agree'},
    {value: 3, label: 'Rather Disagree'},
    {value: 4, label: 'Strongly Disagree'},
    {value: 5, label: 'Undecided/don’t know'}
];